<template>
    <section id="home">
        <header class="valign-wrapper">
            <div class="call-to-action center">
                <h3>More than A Church, We're A Family</h3>
                <div>
                    Growing together in our relationship with Jesus Christ 
                </div>
                <div class="button-div">
                    <a class="waves-effect waves-light btn-large" href="#location">VISIT</a>

                    <!-- <router-link v-if="isLive != ''" 
                        class="waves-effect waves-light btn-large latest-sermon live" 
                        :to="{name: 'live' , params: { videoid: isLive }}"><i class="ln ln-icon-Video-5"></i> WATCH NOW
                    </router-link> -->

                    <!-- <router-link v-else 
                        class="waves-effect waves-light btn-large latest-sermon" 
                        :to="{name: 'sermons'}"><i class="ln ln-icon-Video-5"></i> LATEST SERMON
                    </router-link> -->

                    <a v-if="isLive != ''" class="waves-effect waves-light btn-large latest-sermon live" href="https://www.facebook.com/pg/houseoffirechristian/videos/" target="_blank"><i class="ln ln-icon-Video-5"></i> WATCH NOW</a>

                    <a v-else class="waves-effect waves-light btn-large latest-sermon" href="https://www.youtube.com/@houseoffirechristianchurch/videos" target="_blank"><i class="ln ln-icon-Video-5"></i> LATEST SERMONS</a>
                    <!-- https://www.facebook.com/pg/houseoffirechristian/videos/ -->

                </div>
            </div>
        </header>
    </section>
</template>

<script>
    import ENV from '../../constants/Environment.js';
    import LiveStreamService from '../../services/LiveStream.js';

    export default {
        name: 'Header',
        data: function() {
            return {   
                facebookLive: ENV.FACEBOOK_LIVE_LINK, 
                isLive: ""
            }
        },
        created: function() {
            var self = this;
            LiveStreamService.getVideo().then(function(response) {
                response = response[0];
                if (response != "" && (response.VideoID != "" && response.Status == "LIVE")) {
                    self.isLive = response.VideoID;
                }
            })
        }
    }
</script>

<style scoped>
    header {
        height: 100vh;
        width: 100%;
        background: url("/assets/images/header.jpg");
        /* top: -70px; */
        position: relative;
        min-height: 500px;
    }

    .call-to-action {
        margin: 0 auto;
        font-size: 2rem;
        
    }

    .call-to-action .button-div {
        margin-top: 25px;
    }

    .call-to-action .button-div a{ 
        border: 2px solid;
        background: rgba(0,0,0,.1);
        /* width: 150px; */
        /* height: 51px; */
        /* line-height: 54px; */
        transition: .3s ease-out;

        line-height: 54px;
        font-size: 1.25rem;
        padding: 0px 50px;
        /* background: #5b7c8a; */
    }

    .call-to-action .button-div a:hover { 
        background: rgba(91,124,138, .7);
        border-color: rgba(91,124,138, .7);
        color: #fff;
    }

    .latest-sermon {
        line-height: 45px !important;
        margin-left: 15px;
    }

    .latest-sermon i {
        position: relative;
        top: 3px;
        padding-right: 5px;
    }

    .live {
        border-color: rgba(176,16,48, 1) !important;
        background: rgba(176,16,48,1) !important;
        transition: .3s ease-out;
        box-shadow: 0px 0px 35px #030303;
    }

    .live:hover {
        border-color: rgba(176,16,48, .7) !important;
        background: rgba(176,16,48,.7) !important;
    }

    @media (max-width: 500px) {
        .call-to-action .button-div a {
            width: 75%; 
            padding: 0px;
        }

        .latest-sermon {
            margin-top: 15px;
            margin-left: 0px;
        }
    }
</style>